/**
 * Ícone de sino (line-icon) — C-24.
 * Espelha o `ic('bell')` do protótipo V8 (L1020), que é como o V8 desenha o 🔔 do header:
 * SVG com `stroke="currentColor"`, mesmo padrão do `PhoneIcon` do botão de contatos de
 * emergência ao lado. Substitui o emoji, que renderiza colorido e destoa do box.
 */
export function BellIcon({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0 }}
    >
      <path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4l2-2Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </svg>
  );
}
